<template>
  <v-row class=" row row-height">
    <successModal
      ref="success_modal"
      v-on:confirm="closeSuccessModal"
    ></successModal>

    <div class="col-md-12">
          <div class="row mt-1" style="margin-left: -11px">
      <div class="col-md-12">
        <h3 class="form-title font mb-2 ml-3">Bank Information</h3>
      </div>
    </div>
      <v-form v-model.trim="valid" ref="form" class="row">
        <div class="col-md-6">
          <div class="col-md-12 pb-0">
            <label class="font text-gray" for="">Bank Name</label>
            <v-text-field
              required
              :rules="requiredRules"
              v-model.trim="companyName"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Bank Branch</label>
            <v-text-field
              required
              :rules="requiredRules"
              v-model.trim="displayName"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""> Address Line 1</label>
            <v-text-field
              required
              v-model.trim="address1"
              :rules="requiredRules"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""> Address Line 2</label>
            <v-text-field required v-model.trim="address2" solo></v-text-field>
          </div>
          <v-row class="no-padding">
            <div class="col-md-6 pb-0 pt-0">
              <label class="font text-gray" for="">City</label>
              <v-text-field
                required
                v-model.trim="city"
                solo
                :rules="requiredRules"
              ></v-text-field>
            </div>
            <div class="col-md-3 pb-0 pt-0" >
              <label class="font text-gray" for="">State</label>
              <v-select
                :items="states"
                item-text="name"
                item-value="name"
                required
                v-model.trim="state"
                solo
                :rules="requiredRules"
              ></v-select>
            </div>
            <div class="col-md-3 pb-0 pt-0">
              <label class="font text-gray" for="">Zip</label>
              <v-text-field
                required
                type="number"
                v-model.trim="zip"
                solo
                :rules="zipRules"
              ></v-text-field>
            </div>
          </v-row>
           <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""> Branch Manager First Name </label>
            <v-text-field
              required
              v-model.trim="address1"
              :rules="requiredRules"
              solo
            ></v-text-field>
          </div>
           <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""> Branch Manager Last Name </label>
            <v-text-field
              required
              v-model.trim="address1"
              :rules="requiredRules"
              solo
            ></v-text-field>
          </div>

        </div>
        <div class="col-md-6">
          <div class="col-md-12 pb-0">
            <label class="font text-gray" for=""
              >Recipient Legal Name
            </label>
            <v-text-field
              required
              v-model.trim="firstName"
              solo
              :rules="requiredRules"
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""
              >EIN</label
            >
            <v-text-field
              required
              v-model.trim="lastName"
              solo
              :rules="requiredRules"
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Address 1</label>
            <v-text-field
              required
              v-model.trim="title"
              solo
              :rules="requiredRules"
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Address 2</label>
            <v-text-field
              required
              :rules="emailRules"
              v-model.trim="email"
              solo
            ></v-text-field>
          </div>
              <v-row class="no-padding">
            <div class="col-md-6 pb-0 pt-0">
              <label class="font text-gray" for="">City</label>
              <v-text-field
                required
                v-model.trim="city"
                solo
                :rules="requiredRules"
              ></v-text-field>
            </div>
            <div class="col-md-3 pb-0 pt-0">
              <label class="font text-gray" for="">State</label>
              <v-select
                :items="states"
                item-text="name"
                item-value="name"
                required
                v-model.trim="state"
                solo
                :rules="requiredRules"
              ></v-select>
            </div>
            <div class="col-md-3 pb-0 pt-0">
              <label class="font text-gray" for="">Zip</label>
              <v-text-field
                required
                type="number"
                v-model.trim="zip"
                solo
                :rules="zipRules"
              ></v-text-field>
            </div>
          </v-row>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Inbound Rounding Number</label>
            <v-text-field
              required
              v-model.trim="phone"
              solo
             
            ></v-text-field>
          </div>
            <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Inbound Account Number</label>
            <v-text-field
              required
              v-model.trim="phone"
              solo
             
            ></v-text-field>
          </div>
    
        </div>
      </v-form>
        <div
      class="row text-end justify-end gray-underline-wizard "
      style="margin-left: -11px"
    >
      <div class="col-md-12 mt-2 mb-2">
        <span class="text-underline text-gray col-md-12 " @click="update">Save</span>
      </div>
    </div>
    </div>
  
  </v-row>
</template>
<script>
import api from "../../../../../services/api";
import successModal from "../../../../TablesTemplate/SuccessDialog.vue";

export default {
  components: { successModal },
  data() {
    return {
      companyName: "",
      taxId: "",
      website: "",
      logo: "",
      phone: "",
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      website: "",
      displayName: "",
      companyLogo: {
        name: "",
      },
      phoneRules: [
        (v) =>
          /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(v) ||
          "Phone number must be in a valid format (XXX XXX XXXX)",
      ],
      states: [],
      discountRate: "",
      valid: false,
      zipRules: [
        (v) => (v && v.length == 5) || " Zip Code should be five digits long",
      ],
      requiredRules: [(v) => !!v || "This field is required"],
      imageEvent: null,
      emailRules: [
        (v) => !!v || "This field is required",
        (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-mail must be valid",
      ],
      logoChange: false,
      profileChange: false,
      imageProfleEvent: null,
      dataComponents: {
        image: {
          name: "",
        },
        profileImage: {
          name: "",
        },
      },
      taxIdRules: [
        (v) => !!v || "This field is required",
        (v) =>
          !!/[0-9]{2}\-[0-9]{7}/.test(v) ||
          "Tax ID should contain 9 digits, Please enter your Tax ID in XX-XXXXXXX format",
      ],
    };
  },
  computed: {
    singleEmp() {
      let provider = "";
      if (localStorage.getItem("employer")) {
        provider = JSON.parse(localStorage.getItem("employer"));
      }

      return provider;
    },
  },
  created() {
    // this.getStates();
    // this.getInfo();
  },
  methods: {
    generatePdf() {
      window.open("https://api.apaly.net/terms");
    },
    showSlash(event) {
      if (this.taxId.length == 2 && event.keyCode != 8) {
        this.taxId += "-";
      }
    },
    activateFileInput() {
      this.$refs.fileInput.$refs.input.click();
    },
    getStates() {
      api()
        .get("/api/states")
        .then((res) => {
          res.data.forEach((el) => {
            if (el.active) {
              this.states.push(el);
            }
          });
        });
    },
    getInfo() {
      let user = JSON.parse(localStorage.getItem("user"));
      let provider = user.entity._id;

      api()
        .get(`/providers/${provider}`)
        .then((res) => {
          if (res) {
            this.companyName = res.data.provider.providerName
              ? res.data.provider.providerName
              : res.data.provider.companyName
              ? res.data.provider.companyName
              : "";
            this.displayName = res.data.provider.displayName
              ? res.data.provider.displayName
              : "";
            this.taxId = res.data.provider.taxId ? res.data.provider.taxId : "";
            this.address1 = res.data.provider.address1
              ? res.data.provider.address1
              : "";
            this.address2 = res.data.provider.address2
              ? res.data.provider.address2
              : "";
            this.website = res.data.provider.website
              ? res.data.provider.website
              : "";
            this.city = res.data.provider.city ? res.data.provider.city : "";
            this.state = res.data.provider.state ? res.data.provider.state : "";
            this.zip = res.data.provider.zipCode
              ? res.data.provider.zipCode
              : "";
            this.firstName = res.data.provider.primaryContact.firstName
              ? res.data.provider.primaryContact.firstName
              : "";
            this.lastName = res.data.provider.primaryContact.lastName
              ? res.data.provider.primaryContact.lastName
              : "";
            this.title = res.data.provider.primaryContact.title
              ? res.data.provider.primaryContact.title
              : "";
            this.phone = res.data.provider.primaryContact.phone
              ? res.data.provider.primaryContact.phone
              : "";
            this.email = res.data.provider.primaryContact.email
              ? res.data.provider.primaryContact.email
              : "";
            this.dataComponents.image.name = res.data.provider.logo
              ? res.data.provider.logo
              : "";
            this.dataComponents.profileImage.name = res.data.provider
              .primaryContact.profile
              ? res.data.provider.primaryContact.profile
              : "";
          }
        });
    },
    closeSuccessModal() {
      this.$refs.success_modal.closePopUp();
    },
    updateLogoOrProfile() {
      //   let user = JSON.parse(localStorage.getItem("user"));
      //   let provider = user.entity._id;
      //   if (this.imageProfleEvent) {
      //     let formData = new FormData();
      //     formData.append("_method", "PUT");
      //     formData.append("image", this.imageProfleEvent);
      //     api()
      //       .put(`/providers/${provider}/profile`, formData)
      //       .then((res) => {
      //         document.getElementById("profile-img").click();
      //       });
      //   } else {
      //     api()
      //       .delete(`/providers/${provider}/profile`)
      //       .then((res) => {
      //         document.getElementById("profile-img").click();
      //       });
      //   }
      //   if (this.imageEvent) {
      //     let formData = new FormData();
      //     formData.append("_method", "PUT");
      //     formData.append("image", this.imageEvent);
      //     api()
      //       .put(`/providers/${provider}/logo`, formData)
      //       .then((res) => {
      //         document.getElementById("logo-img").click();
      //       });
      //   } else {
      //     api()
      //       .delete(`/providers/${provider}/logo`)
      //       .then((res) => {
      //         document.getElementById("profile-img").click();
      //       });
      //   }
    },
    update() {
      this.$refs.form.validate();
      if (false) {
        let data = {
          companyName: this.companyName,
          providerName: this.companyName,
          displayName: this.displayName,
          address1: this.address1,
          address2: this.address2,
          website: this.website,
          city: this.city,
          state: this.state,
          zipCode: this.zip,
          taxId: this.taxId,
          firstName: this.firstName,
          lastName: this.lastName,
          title: this.title,
          phone: this.phone,
          email: this.email,
        };

        let user = JSON.parse(localStorage.getItem("user"));
        let provider = user.entity._id;
        let formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("image", this.imageEvent);

        api()
          .put(`/providers/${provider}`, data)
          .then((res) => {
            if (res) {
              if (this.profileChange) {
                if (this.imageProfleEvent) {
                  let formData = new FormData();
                  formData.append("_method", "PUT");
                  formData.append("image", this.imageProfleEvent);
                  api()
                    .put(`/providers/${provider}/profile`, formData)
                    .then((res) => {
                      document.getElementById("profile-img").click();
                    });
                } else {
                  api()
                    .delete(`/providers/${provider}/profile`)
                    .then((res) => {
                      document.getElementById("profile-img").click();
                    });
                }
              }
              if (this.logoChange) {
                if (this.imageEvent) {
                  let formData = new FormData();
                  formData.append("_method", "PUT");
                  formData.append("image", this.imageEvent);
                  api()
                    .put(`/providers/${provider}/logo`, formData)
                    .then((res) => {
                      document.getElementById("logo-img").click();
                    });
                } else {
                  api()
                    .delete(`/providers/${provider}/logo`)
                    .then((res) => {
                      document.getElementById("logo-img").click();
                    });
                }
              }

              this.$refs.success_modal.openPopUp(
                "Account updated successfully"
              );
              this.logoChange = false;
              this.profileChange = false;
            }
          });
      }

      this.$refs.success_modal.openPopUp("Account updated successfully");
    },
    activateProfileInput() {
      this.$refs.profileInput.$refs.input.click();
    },
    Preview_image(event) {
      this.logoChange = true;
      this.imageEvent = event;
    },
    Preview_profileImage(event) {
      this.profileChange = true;
      this.imageProfleEvent = event;
    },
  },
};
</script>